import { createFileRoute } from "@tanstack/react-router";
import { formatPageIdentifier, pageHead } from "../../../utils/page-title";

export const Route = createFileRoute("/compatibility/with/$username")({
  head: ({ params }) => ({
    ...pageHead(`Compatibility with ${formatPageIdentifier(params.username)}`, {
      canonicalPath: `/compatibility/with/${params.username}`,
      robots: "noindex, nofollow",
    }),
  }),
});
